import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../common/global.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  error: string = '';
  dataval: any[] = [];
  orgname: string = '';
  ddshow: boolean = false;  
  constructor(private router: Router, private globalService: GlobalService) {
   
  }

  ngOnInit(): void {
     this.router.navigate(['/CMA/cmadashboard/0']);
   let data = sessionStorage.getItem('Usertype');
   if (data === 'MAWS')       
    this.router.navigate(['/MAWS/mawsdashboard/0']);
  else  if (data === 'DTP')       
    this.router.navigate(['/DTP/dtpdashboard/0']);
    else
      this.router.navigate(['/CMA/cmadashboard/0']);
  }

  onSubmit(loginForm: any) {
    this.router.navigate(['/CMA/cmadashboard/0']);

    console.log(loginForm.value.password);
    
    this.globalService
    //.getUserContext(loginForm.value.userName, loginForm.value.password)
    .getUserContext(loginForm.value.userName, encodeURIComponent(loginForm.value.password))
    .subscribe(
        (data) => {
          this.dataval = data;
          console.log(loginForm.value.password);
          //console.log(this.dataval[0].UserTypeID);
          console.log(data);
          //console.log(data.CreatedDate);
            if (data.length > 0) 
            {
                this.orgname = this.dataval[0].OrganizationName.split(' ')[0] //this.dataval[0].OrganizationName
                sessionStorage.setItem('DesignationName', this.dataval[0].DesignationName);

                if (this.dataval[0].UserTypeID === 14 )
                {
                  sessionStorage.setItem('wbshow', '1');
                }
                else
                {
                  sessionStorage.setItem('wbshow', '0');
                }

                if (this.dataval[0].UserTypeID === 127 )
                {
                    sessionStorage.setItem('Organization_Name', this.dataval[0].OrganizationName);
                    if (this.dataval[0].Dutyid === 0)
                    {
                      sessionStorage.setItem('OrganizationName', this.orgname);
                      sessionStorage.setItem('RegionID', this.dataval[0].RegionID===null?0:this.dataval[0].RegionID);
                      sessionStorage.setItem('RegionName', this.dataval[0].RegionName);
                      sessionStorage.setItem('OrganizationTypeID', this.dataval[0].OrganizationTypeID);
                      sessionStorage.setItem('Dutyid', this.dataval[0].Dutyid);
                    }

                    sessionStorage.setItem('userContext', JSON.stringify(data));
                    sessionStorage.setItem('Usertype', 'DTP');
                    sessionStorage.setItem('OrganizationID', this.dataval[0].OrganizationID);
                    sessionStorage.setItem('GeneratedBy', this.dataval[0].FirstName);
                    sessionStorage.setItem('org_name', this.dataval[0].OrganizationName);
                    sessionStorage.setItem('Dutyid', this.dataval[0].Dutyid);
                    this.router.navigate(['/DTP/dtpdashboard/0']);
                }
                else if (this.dataval[0].UserTypeID === 17 )
                {
                    sessionStorage.setItem('Organization_Name', this.dataval[0].OrganizationName);
                    if (this.dataval[0].Dutyid === 0)
                    {
                      sessionStorage.setItem('OrganizationName', this.orgname);
                      sessionStorage.setItem('RegionID', this.dataval[0].RegionID===null?0:this.dataval[0].RegionID);
                      sessionStorage.setItem('RegionName', this.dataval[0].RegionName);
                      sessionStorage.setItem('OrganizationTypeID', this.dataval[0].OrganizationTypeID);
                      sessionStorage.setItem('Dutyid', this.dataval[0].Dutyid);
                    }

                    sessionStorage.setItem('userContext', JSON.stringify(data));
                    sessionStorage.setItem('Usertype', 'MAWS');
                    sessionStorage.setItem('OrganizationID', this.dataval[0].OrganizationID);
                    sessionStorage.setItem('GeneratedBy', this.dataval[0].FirstName);
                    sessionStorage.setItem('org_name', this.dataval[0].OrganizationName);
                    sessionStorage.setItem('Dutyid', this.dataval[0].Dutyid);
                    this.router.navigate(['/MAWS/mawsdashboard/0']);
                }
                else  if (  this.dataval[0].UserTypeID === 2 || 
                            this.dataval[0].UserTypeID === 3 || 
                            this.dataval[0].UserTypeID === 9 ||
                            this.dataval[0].UserTypeID === 14)
                {
                    sessionStorage.setItem('Organization_Name', this.dataval[0].OrganizationName);
                                        
                    if (this.dataval[0].Dutyid > 0)
                    {
                     
                        sessionStorage.setItem('OrganizationName', this.orgname);                       
                        sessionStorage.setItem('RegionName', this.dataval[0].RegionName);
                        sessionStorage.setItem('OrganizationTypeID', this.dataval[0].OrganizationTypeID);
                        sessionStorage.setItem('Dutyid', this.dataval[0].Dutyid);
                        sessionStorage.setItem('OrganizationID', this.dataval[0].OrganizationID);

                          if (this.dataval[0].OrganizationID === 16
  || this.dataval[0].OrganizationID === 26 || this.dataval[0].OrganizationID === 50
|| this.dataval[0].OrganizationID === 63 || this.dataval[0].OrganizationID === 101
|| this.dataval[0].OrganizationID === 102 || this.dataval[0].OrganizationID === 103)
{
 sessionStorage.setItem('RegionID', '0');
}
else
{
 sessionStorage.setItem('RegionID', this.dataval[0].RegionID);
}
                       //sessionStorage.removeItem('ProductName');
                    }
                    sessionStorage.setItem('Usertype', 'CMA');

                    if ( this.dataval[0].DesignationName !== null)
                    {
                      sessionStorage.setItem('GeneratedBy',(this.dataval[0].FirstName +" "+this.dataval[0].DesignationName)  );
                      sessionStorage.setItem('org_name', this.dataval[0].OrganizationName);
                    }
                    else
                    {
                      sessionStorage.setItem('GeneratedBy',"IT Section");
                      sessionStorage.setItem('org_name', this.dataval[0].OrganizationName);
                    }

                    sessionStorage.setItem('userContext', JSON.stringify(data));
                    if (this.dataval[0].Dutyid === 0)
                      sessionStorage.setItem('OrganizationID', '5');
                    else
                      sessionStorage.setItem('OrganizationID', this.dataval[0].OrganizationID);

                    if ( this.dataval[0].UserTypeID === 9)
                    {
                      this.router.navigate(['/CMA/cmadashboard/0']);
                      // this.router.navigate(['/MAS/cmamasdashboard/0']);                      
                    }
                    else
                    {
                    this.router.navigate(['/CMA/cmadashboard/0']);
                    }
                }
                else  if ( this.dataval[0].UserTypeID === 8)
                {
                    sessionStorage.setItem('Organization_Name', this.dataval[0].FirstName +" " + this.dataval[0].OrganizationName);
                    if (this.dataval[0].Dutyid > 0)
                    {
                        sessionStorage.setItem('OrganizationName',this.dataval[0].FirstName +" " + this.dataval[0].OrganizationName);
                        sessionStorage.setItem('RegionID', this.dataval[0].RegionID);
                        sessionStorage.setItem('RegionName', this.dataval[0].RegionName);
                        sessionStorage.setItem('OrganizationTypeID', this.dataval[0].OrganizationTypeID);
                        sessionStorage.setItem('Dutyid', this.dataval[0].Dutyid);
                        //sessionStorage.removeItem('ProductName');
                    }
                    sessionStorage.setItem('Usertype', 'CMA');

                    if ( this.dataval[0].DesignationName !== null)
                    {
                      sessionStorage.setItem('GeneratedBy',(this.dataval[0].FirstName +" "+this.dataval[0].DesignationName)  );
                      sessionStorage.setItem('org_name', this.dataval[0].OrganizationName);

                    }
                    else
                    {
                      sessionStorage.setItem('GeneratedBy',"IT Section");
                      sessionStorage.setItem('org_name', this.dataval[0].OrganizationName);

                    }

                    sessionStorage.setItem('userContext', JSON.stringify(data));
                    sessionStorage.setItem('OrganizationID', this.dataval[0].OrganizationID);
                    this.router.navigate(['/CMA/cmadashboard/0']);
              }
              else 
              {
                  this.error = 'Invalid User Name or Password...';
                  this.router.navigate(['/MAWS/mawsdashboard/0']);
              }
            }
            else  if (data.length === 0) {
               // this.error = 'Sorry for the InConvenience... Dashboard is under DMA Review...';
               this.error = 'Invalid User Name or Password...';
            }

        },
        (err) => {
          console.log(err);
          this.error = 'Invalid User Name111 or Password...';
        }
      );
  }

  multiOrg()
  {
    this.ddshow = true;
  }
}
